'use strict';

const jQuery = require('jquery');

export default ReportNaturePlaceSelect;

const REPORT_NATURE_PLACE_SELECT_COMPONENT_ATTR = 'data-report-nature-place-select';
const REPORT_NATURE_PLACE_SELECT_COMPONENT_SELECTOR = '[' + REPORT_NATURE_PLACE_SELECT_COMPONENT_ATTR + ']';
const REPORT_NATURE_PLACE_SELECT_PLACE = '[data-report-nature-place-select-place]';
const REPORT_NATURE_PLACE_SELECT_GENERATE = '[data-report-nature-place-select-generate]';

class ReportNaturePlaceSelect {

    constructor(element) {
        const component = this;

        component.element = jQuery(element);
        component.selectCategory = component.element.find(REPORT_NATURE_PLACE_SELECT_PLACE);
        component.buttonGenerate = component.element.find(REPORT_NATURE_PLACE_SELECT_GENERATE);

        component.buttonGenerate.prop('disabled', true);

        component.selectCategory.on('change', () => {
            component.buttonGenerate.prop('disabled', false);
        });
    }

}

jQuery(REPORT_NATURE_PLACE_SELECT_COMPONENT_SELECTOR).each((index, element) => new ReportNaturePlaceSelect(element));
